// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "login_home_welcome" + "." + "36fa6e1b" + ".css";
};